import styled from "styled-components";
import { memo } from "react";
import CheckMark from "../../../../../../assets/checkmark.svg";
import "./sku-product-card.scss";

const Checkmark = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  background-image: url(${CheckMark});
  background-size: cover;
`;

const ProductCardBase = ({ product, selected, onSelect }) => {
  return (
    <button
      className={`sku-product-card ${selected ? "selected" : ""}`}
      onClick={() => onSelect(product.id)}
      type="button"
    >
      <img
        className="product-image"
        src={product.image}
        alt={product.title}
        loading="lazy"
      />
      <Checkmark className="icon-selected" />
      <div className="product-details">
        <span className="font-body-bold">{product.title}</span>
        <span className="font-xsmall-regular keyword">
          {product.keyword.join(", ")}
        </span>
      </div>
    </button>
  );
};

export const ProductCard = memo(ProductCardBase, (prev, next) => {
  return (
    prev.product.id === next.product.id &&
    prev.selected === next.selected &&
    prev.onSelect === next.onSelect
  );
});
